import {makeGetExamRequestReports} from 'main/factories/usecases/private/exam-results/get-exam-request-reports';
import {GetExamRequestsParams} from './types';

export const getExamRequestReports = async ({signal, nuPedido}: GetExamRequestsParams) => {
	const response = await makeGetExamRequestReports(nuPedido).get({signal});

	return response;
};
